import { jsx as r, jsxs as e } from "react/jsx-runtime";
import m from "@material-ui/core/Box";
import M from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Container";
import B from "@material-ui/core/Dialog";
import T from "@material-ui/core/DialogActions";
import I from "@material-ui/core/DialogContent";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormHelperText";
import l from "@material-ui/core/Grid";
import P from "@material-ui/core/IconButton";
import "@material-ui/core/InputBase";
import u from "@material-ui/core/InputLabel";
import N from "@material-ui/core/Link";
import "@material-ui/core/OutlinedInput";
import "@material-ui/core/styles/createStyles";
import L from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Tab";
import p from "@material-ui/core/Typography";
import j from "@material-ui/icons/Close";
import "@material-ui/icons/Copyright";
import "@material-ui/icons/HowToReg";
import "@material-ui/icons/MailOutline";
import "@material-ui/icons/Payment";
import "@material-ui/icons/Portrait";
import "@material-ui/icons/SmsOutlined";
import "@material-ui/icons/WarningOutlined";
import q from "@material-ui/lab/Alert";
import "@material-ui/lab/TabContext";
import "@material-ui/lab/TabList";
import "@material-ui/lab/TabPanel";
import { TextField as f, PasswordStrength as A, normalizePhoneNumber as D } from "@propify-tenant-client/common";
import { AccountService as E, api as R, handleError as U } from "@propify-tenant-client/services";
import W from "classnames";
import { Formik as $, Form as z } from "formik";
import { useState as h } from "react";
import * as s from "yup";
const G = s.object({
  password: s.string().min(6, "Password must contain at least 6 characters").required("Enter your password"),
  confirm: s.string().required("Confirm your password").oneOf([s.ref("password")], "Password does not match")
}), O = L({
  form: {
    "& label.Mui-required .MuiInputLabel-asterisk": {
      color: "red"
    },
    "& .MuiGrid-item": {
      margin: 8
    },
    "&.noMargin .MuiGrid-item": {
      margin: "8px 0"
    },
    "& label": {
      color: "black",
      fontWeight: "500",
      marginBottom: 8,
      fontSize: "0.93rem"
    },
    "& .MuiOutlinedInput-input": {
      height: "0.5em"
    },
    "& .MuiInputBase-input, & .MuiInputBase-multiline": {
      background: "#EBF5FF",
      borderColor: "#CDDFF0"
    },
    "& .messageField textarea": {
      minHeight: 100
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: -5
    }
  }
}), Ar = ({
  open: g,
  onClose: c,
  onSignIn: w,
  lead: i,
  redirectLink: y,
  onRegisterSubmit: b
}) => {
  const k = O(), [C, S] = h(!1), [x, d] = h(!1);
  return /* @__PURE__ */ r(
    $,
    {
      enableReinitialize: !0,
      validationSchema: G,
      initialValues: {
        password: "",
        confirm: ""
      },
      onSubmit: (t) => {
        d(!0), b(), i && E.register({
          ...t,
          firstName: i.firstName,
          email: i.email,
          lastName: i.lastName,
          phoneNumber: D(i.phone)
        }).then((o) => {
          const n = `${R.BASE_URL}/user/login?accessToken=${o.auth}`;
          location.href = `${n}&redirect=${encodeURIComponent(y)}`;
        }).catch((o) => {
          U(o, {
            toastFallbackMessage: o.response.status === 409 ? "There is already a user with that email" : "There was an error registering the user"
          });
        }).finally(() => {
          d(!1);
        });
      },
      children: ({ touched: t, errors: o, setFieldValue: n, values: v, submitForm: F }) => /* @__PURE__ */ r(z, { children: /* @__PURE__ */ e(
        B,
        {
          open: g,
          onClose: () => {
            c();
          },
          maxWidth: "md",
          children: [
            /* @__PURE__ */ e(I, { children: [
              /* @__PURE__ */ e(
                m,
                {
                  style: { display: "flex", justifyContent: "space-between", alignItems: "center" },
                  children: [
                    /* @__PURE__ */ r(q, { severity: "success", children: "Thank you for submitting the form! One of our agents will get back to you soon." }),
                    /* @__PURE__ */ r(P, { onClick: c, children: /* @__PURE__ */ r(j, {}) })
                  ]
                }
              ),
              /* @__PURE__ */ r(m, { mt: 2, children: /* @__PURE__ */ r(p, { variant: "h6", children: "Schedule a Self-Showing Today!" }) }),
              /* @__PURE__ */ r(m, { mt: 1, children: /* @__PURE__ */ r(p, { variant: "caption", style: { marginTop: 17 }, children: "Create an account today and schedule your tour without waiting by entering a password below. You may be asked to verify your identity to complete registration." }) }),
              /* @__PURE__ */ e(
                l,
                {
                  container: !0,
                  spacing: 2,
                  className: W(k.form, "enable-default-input-background", "noMargin"),
                  children: [
                    /* @__PURE__ */ e(l, { item: !0, xs: 6, children: [
                      /* @__PURE__ */ r(u, { htmlFor: "password", required: !0, children: "Password" }),
                      /* @__PURE__ */ r(
                        f,
                        {
                          id: "password",
                          name: "password",
                          helperText: t.password ? o.password : "",
                          error: t.password && !!o.password,
                          fullWidth: !0,
                          type: "password",
                          variant: "outlined",
                          onChange: (a) => {
                            n("password", a.target.value), S(!!a.target.value);
                          },
                          autoFocus: !0
                        }
                      ),
                      C && /* @__PURE__ */ r(A, { password: v.password })
                    ] }),
                    /* @__PURE__ */ e(l, { item: !0, xs: 6, children: [
                      /* @__PURE__ */ r(u, { htmlFor: "confirm", required: !0, children: "Confirm Password" }),
                      /* @__PURE__ */ r(
                        f,
                        {
                          id: "confirm",
                          name: "confirm",
                          helperText: t.confirm ? o.confirm : "",
                          error: t.confirm && !!o.confirm,
                          fullWidth: !0,
                          type: "password",
                          variant: "outlined",
                          onChange: (a) => {
                            n("confirm", a.target.value);
                          }
                        }
                      )
                    ] })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e(T, { style: { justifyContent: "space-between" }, children: [
              /* @__PURE__ */ e(p, { children: [
                "Already have an account? ",
                /* @__PURE__ */ r(N, { onClick: () => w(), children: "Click here" }),
                " to Sign In."
              ] }),
              /* @__PURE__ */ r(M, { variant: "contained", color: "primary", onClick: F, disabled: x, children: "Sign Up" })
            ] })
          ]
        }
      ) })
    }
  );
};
export {
  Ar as default
};
//# sourceMappingURL=RegisterModal.js.map
